import { render, staticRenderFns } from "./PasswordLessLoginForm.vue?vue&type=template&id=18d0e0b8&scoped=true&"
import script from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"
export * from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0e0b8",
  null
  
)

export default component.exports